var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('img',{staticClass:"iconname",attrs:{"src":_vm.iconname}}),_c('div',{staticClass:"breadname"},[_vm._v(_vm._s(_vm.name)+" "),(_vm.landname)?_c('span',[_vm._v("-- "+_vm._s(_vm.landname))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }